const cacheKey = 'driverIndicationStatuses'

export default {
  data: () => ({
    driverIndicationStatuses: []
  }),
  methods: {
    loadDriverIndicationStatuses() {
      const cached = this.$ls.get(cacheKey)
      if (cached) {
        this.driverIndicationStatuses = cached
        return Promise.resolve(cached)
      }

      return this.axios.get('admin/maestro/driver_indication_statuses?meta=false&per_page=1000')
        .then(response => {
          this.driverIndicationStatuses = response.data
          this.$ls.set(cacheKey, response.data, { minutes: 1 })
          return response.data
        })
        .catch(e => {
          this.$notify.addError(e)
          return []
        })
    },
    findStatus(indication) {
      const statusId = indication && indication.driver_indication_status_id
      if (!statusId) return null

      return this.driverIndicationStatuses.find(status => status.id === statusId) || null
    }
  }
}
